module.exports = __webpack_public_path__ + "img/banner801.028e248c.jpeg";